import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Css/Navbar.css";
import "../Css/style2.css";
import { DefaultSidebar } from "./Sidenav";

export default function Navbar() {
  const [check, setcheck] = useState("");
  const [logcheck, setlogcheck] = useState("");
  const location = useLocation();

 
  let Token;
  if (localStorage.getItem("Token")) {
    Token = true;
  } else {
    Token = false;
  }
  const islogged = (token) => {
    if (!token) {
      setcheck("d-none");
      setlogcheck("d-block");
    } else {
      setcheck("d-block");
      setlogcheck("d-none");
    }
  };
  useEffect(() => {
    islogged(Token);
  });
  return (
    <div className="sticky top-0 z-3">
      <nav class="sticky inset-0 z-10 block h-max w-full max-w-full rounded-none border border-white/80 bg-white bg-opacity-80 py-2 px-4 text-white shadow-md backdrop-blur-2xl backdrop-saturate-200 lg:px-8 lg:py-4">
        <div class="flex items-center text-gray-900 justify-between">
        <Link to="/">
              <img
                src="https://i.ibb.co/c26z2hZ/image-removebg-preview-11.png"
                alt="image-removebg-preview-11"
                border="0"
                width={"50px"}
              />
            </Link>
          <ul class="ml-auto mr-8 hidden items-center gap-6 lg:flex mb-0">
            <li class="block p-1 font-sans text-sm font-normal leading-normal text-inherit antialiased">
            <a
                  className={`flex items-center ${
                    location.pathname === "/home" ? "active" : ""
                  } ${check}`}
                  aria-current="page"
                  href="/home"
                >
                  Tasks
                </a>
            </li>
            <li class="block p-1 font-sans text-sm font-normal leading-normal text-inherit antialiased">
             
              <Link className="flex items-center" to="/" data-scroll-nav="0">
                  Home
                </Link>
            </li>
            <li class="block p-1 font-sans text-sm font-normal leading-normal text-inherit antialiased">
              
              <Link
                  className={`flex items-center ${
                    location.pathname === "/About" ? "active" : ""
                  }`}
                  to="/About"
                >
                  About
                </Link>
            </li>
            <li class="block p-1 font-sans text-sm font-normal leading-normal text-inherit antialiased">
              <a class="flex items-center" href="#">
                Docs
              </a>
            </li>
            <form className="d-flex jcc" role="search">
           
              <div className="d-flex ">
                <Link to="/signup">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    Sign Up
                  </button>
                </Link>
                <Link to="/login">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    LogIn
                  </button>
                </Link>
                
              </div>
            </form>

          </ul>
          
            <div className="d-flex">
            <Link
                  to="/profile"
                  className={`text-decoration-none ${check} text-theme`}
                >
              <i className="fa-solid fa-circle-user fs-4 mx-1"></i>
              </Link>
            </div>
          
          <a
        className="btn btn-primary mdpx dis-none"
        data-bs-toggle="offcanvas"
        href="#offcanvasExample"
        role="button"
        aria-controls="offcanvasExample"
      >
        <i className="fa-solid fa-bars"></i>
      </a>
        
        </div>
        
       
      </nav>
      
      {/* <nav className="navbar navbar-expand-lg  bg-dark navbar-dark">
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <Link to="/">
              <img
                src="https://i.ibb.co/c26z2hZ/image-removebg-preview-11.png"
                alt="image-removebg-preview-11"
                border="0"
                width={"50px"}
              />
            </Link>
            <Link className="navbar-brand text-light" to="/">
              TaskHero
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className={`nav-link text-light ${
                    location.pathname === "/home" ? "active" : ""
                  } ${check}`}
                  aria-current="page"
                  to="/home"
                >
                  Tasks
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link text-light ${
                    location.pathname === "/about" ? "active" : ""
                  }`}
                  to="/About"
                >
                  About
                </Link>
              </li>
            </ul>
            <form className="d-flex jcc" role="search">
           
              <div className="d-flex ">
                <Link to="/signup">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    Sign Up
                  </button>
                </Link>
                <Link to="/login">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    LogIn
                  </button>
                </Link>
                <Link
                  to="/profile"
                  className={`text-decoration-none ${check} text-success`}
                >
                  <div className="d-flex">
                    <i className="fa-solid fa-circle-user fs-4 mx-1"></i>
                    <i className="fs-6">Your Profile</i>
                  </div>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </nav> */}
      {/* <nav className="navbar navbar-expand-lg text-dark opacity-0.5">
        <div className="container">
          {" "}
          <a className="navbar-brand navbar-logo" href="#">
            {" "}
            <img
              src="https://i.ibb.co/c26z2hZ/image-removebg-preview-11.png"
              alt="logo"
              className="logo-1"
              width={"100px"}
            />{" "}
          </a>
          <div
            className="collapse navbar-collapse justify-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                {" "}
                <Link className="nav-link text-dark" to="/" data-scroll-nav="0">
                  Home
                </Link>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <Link
                  className={`nav-link test-dark ${
                    location.pathname === "/home" ? "active" : ""
                  } ${check}`}
                  aria-current="page"
                  to="/home"
                >
                  Tasks
                </Link>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a className="nav-link" href="#" data-scroll-nav="2">
                  Features
                </a>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a className="nav-link" href="#" data-scroll-nav="3">
                  Team
                </a>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a className="nav-link" href="#" data-scroll-nav="4">
                  Testimonials
                </a>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a className="nav-link" href="#" data-scroll-nav="5">
                  Faq
                </a>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a className="nav-link" href="#" data-scroll-nav="6">
                  Contact
                </a>{" "}
              </li>
            </ul>

            <form className="d-flex jcc" role="search">
              <div className="d-flex ">
                <Link to="/signup">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    Sign Up
                  </button>
                </Link>
                <Link to="/login">
                  <button
                    className={`btn btn-primary mx-2 ${logcheck}`}
                    type="button"
                  >
                    LogIn
                  </button>
                </Link>
              </div>
            </form>
          </div>
          <Link
            to="/profile"
            className={`text-decoration-none ${check} text-theme`}
          >
            <div className="d-flex">
              <i className="fa-solid fa-circle-user fs-4 mx-1"></i>
            </div>
          </Link>
        </div>
      </nav> */}
      
      <div
        className="offcanvas offcanvas-start offcan"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        
        <div className="offcanvas-body p-0">
         <DefaultSidebar/>
          
        </div>
      </div>
    </div>
  );
}
